import axios from 'axios';

interface AIEnhancementResponse {
  enhancedDescription: string;
  suggestedTitle?: string;
  suggestedTags?: string[];
  suggestedHighlights?: string[];
}

export const enhanceEventDescription = async (
  title: string,
  description: string,
  eventType?: string
): Promise<{
  enhancedDescription: string;
  suggestedTitle?: string;
  suggestedTags: string[];
  suggestedHighlights?: string[];
}> => {
  try {
     // Make a real API call to the server endpoint

     const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/anthropic/enhance`,
        {
           title,
           description,
           eventType,
        },
        {
           headers: {
              'Content-Type': 'application/json',
           },
        }
     );

     // Return the actual API response
     return {
        enhancedDescription: response.data.enhancedDescription,
        suggestedTitle: response.data.suggestedTitle,
        suggestedTags: response.data.suggestedTags || [],
        suggestedHighlights: response.data.suggestedHighlights || [],
     };
  } catch (error) {
    console.error('Error in AI enhancement service:', error);
    
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        throw new Error('Invalid API key. Please check your environment configuration.');
      } else if (error.response?.status === 429) {
        throw new Error('API rate limit exceeded. Please try again later.');
      } else if (error.code === 'ERR_NETWORK') {
        throw new Error('Network error: Please check your internet connection.');
      } else if (error.response?.status === 403) {
        throw new Error('Access forbidden. Please check your API key and permissions.');
      }
      
      // Better error message handling
      const errorMessage = error.response?.data?.error || error.message;
      if (typeof errorMessage === 'object') {
        // If error is an object, try to get a meaningful message
        const message = errorMessage.message || errorMessage.error || JSON.stringify(errorMessage);
        throw new Error(`API request failed: ${message}`);
      }
      throw new Error(`API request failed: ${errorMessage}`);
    }
    
    throw error;
  }
}; 